{
  "slug": "low-iq-scores-explained",
  "title": "Les faibles scores de QI expliqués de manière responsable",
  "description": "Comprendre les fourchettes de QI inférieures, les intervalles de confiance, le fonctionnement adaptatif et pourquoi un score seul ne définit jamais une personne ni n'établit un diagnostic.",
  "summary": "Un QI inférieur décrit la performance sur certaines tâches par rapport à un groupe normal, et nécessite une interprétation attentive et respectueuse, en tenant compte de l’incertitude, des besoins d’accès, du développement et du fonctionnement quotidien.",
  "category": "Interprétation du score de QI",
  "sections": [
    {
      "heading": "Ce qu’un score inférieur peut et ne peut pas signifier",
      "paragraphs": [
        "Sur un moyen-100, SD-15 Échelle, scores below 85 sont inférieurs à la moyenne de la population et les scores sont proches de. 70 Le percentile et la classification exacts dépendent de l'instrument et des normes utilisés, mais ils sont généralement compris entre 0 et 100.",
        "Le résultat ne mesure pas la valeur humaine, la gentillesse, la créativité, l’expérience pratique ou toutes les capacités, mais la langue, l’éducation, l’accès sensoriel ou moteur, la santé, l’attention et les conditions de test peuvent affecter le rendement."
      ]
    },
    {
      "heading": "Un diagnostic ne se fait pas uniquement à partir du QI",
      "paragraphs": [
        "L’évaluation professionnelle de la déficience intellectuelle prend en compte le fonctionnement intellectuel ainsi que le fonctionnement adaptatif dans les domaines conceptuel, social et pratique de la vie, avec un début pendant la période de développement.",
        "Un évaluateur qualifié choisit les mesures appropriées, tient compte des mesures d'adaptation et des antécédents, examine l'intervalle de confiance et intègre l'information provenant de plusieurs sources."
      ]
    },
    {
      "heading": "Utiliser les résultats pour comprendre les besoins de soutien",
      "paragraphs": [
        "Des instructions claires, du temps supplémentaire, le cas échéant, des technologies d’assistance, de l’enseignement et des changements dans l’environnement peuvent être importants, mais il faut aussi s’assurer que les personnes concernées aient accès à des ressources et à des services adaptés.",
        "Si un résultat faible est inattendu ou peut affecter les services, discutez-en avec un professionnel qualifié plutôt que de passer des tests en ligne à plusieurs reprises ou de considérer un seuil comme parfaitement précis."
      ]
    }
  ],
  "faqs": [
    {
      "question": "A un QI inférieur à 70 Déficience intellectuelle?",
      "answer": "Le diagnostic nécessite également une évaluation du fonctionnement adaptatif et des antécédents de développement, en utilisant des normes professionnelles appropriées."
    },
    {
      "question": "Les conditions de test peuvent-elles abaisser un score?",
      "answer": "La fatigue, la maladie, l’anxiété, le décalage linguistique, la distraction, les barrières d’accès et d’autres conditions peuvent affecter la performance."
    }
  ],
  "related": ["iq-80-meaning", "iq-score-ranges-explained", "how-is-iq-measured"],
  "sources": [
    {
      "label": "AAIDD — questions et réponses sur la déficience intellectuelle",
      "url": "https://www.aaidd.org/docs/default-source/intellectualdisability/12th-ed-twenty-questions-faq.pdf"
    },
    {
      "label": "Pearson — WAIS-5 Rapport de score d'échantillon",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    }
  ]
}
